import { type HTMLProps, memo, type ReactNode } from 'react';

import { CARD_VARIANTS } from '../constants';
import * as styles from './CardFooter.styles';

type CardFooterProps = Omit<HTMLProps<HTMLDivElement>, 'ref'> & {
  variant?: CARD_VARIANTS;
  children?: ReactNode;
};

export const CardFooterBase = ({
  variant = CARD_VARIANTS.PRIMARY,
  children = null,
  ...props
}: CardFooterProps) => (
  <div css={(theme) => styles.container(theme, variant)} {...props}>
    <div css={(theme) => styles.waveThree(theme, variant)} />

    <div css={(theme) => styles.waveTwo(theme, variant)} />

    <div css={(theme) => styles.waveOne(theme, variant)} />

    {children}
  </div>
);

CardFooterBase.displayName = 'CardFooter';

export const CardFooter = memo(CardFooterBase);
